export default __webpack_public_path__ + "static/media/upRightArrowHover.18a1f6cb.png";